const TradeTrustKeys = {
  TITLE: "eBL Transfer",
  NETWORK_TYPE: "Select a Network",
  ENDORSEMENT_CHAIN_TITLE: "Endorsement Chain",
  TRANSFER: "Transfer"
}

export default TradeTrustKeys
